module.exports = __webpack_public_path__ + "static/media/typing.03f5b4ed.svg";